import styled from 'styled-components'

const Container = styled.div`
  width: 95%;
  max-width: 900px;
  margin: 0 auto;
  ${props => props.center ? 'text-align: center;' : null}
`

export default Container



// WEBPACK FOOTER //
// ./src/components/Container.js